/**
 * Recovery Cream Hero Section JavaScript
 * Extracted from inline script blocks in sections/recovery-cream-hero.liquid
 * Load via: {{ 'recovery-cream-hero.js' | asset_url | script_tag }}
 */
console.log("RECOVERY_CREAM_HERO_ASSET_LOADED", new Date().toISOString());

(function() {
  'use strict';
  
  // Get price from form data attribute (set by Liquid)
  // NOTE: We re-query productForm on each sync to handle Theme Editor rerenders
  let _cachedProductForm = null;
  let _cachedProductPrice = 0;
  let _cachedCompareAtPrice = 0;
  let _unitPrice = 0; // Always the 1-month per-unit price, never changes with variant selection
  
  function getProductForm() {
    if (!_cachedProductForm || !document.contains(_cachedProductForm)) {
      _cachedProductForm = document.querySelector('.recovery-cream-hero__form');
      if (_cachedProductForm) {
        _cachedProductPrice = _cachedProductForm.dataset.price ? parseInt(_cachedProductForm.dataset.price, 10) / 100 : 0;
        _cachedCompareAtPrice = _cachedProductForm.dataset.compareAtPrice ? parseInt(_cachedProductForm.dataset.compareAtPrice, 10) / 100 : 0;
        // Set unit price from 1-month variant (only once, before variant switching)
        if (_unitPrice <= 0) {
          var _initPackMap = null;
          try {
            var _pmEl = _cachedProductForm.querySelector('[data-veluna-pack-variant-map]');
            if (_pmEl) _initPackMap = JSON.parse(_pmEl.textContent || '{}');
          } catch(e) {}
          if (_initPackMap && _initPackMap['1'] && _initPackMap['1'].price_cents > 0) {
            _unitPrice = _initPackMap['1'].price_cents / 100;
          } else {
            _unitPrice = _cachedProductPrice;
          }
        }
      }
    }
    return _cachedProductForm;
  }
  
  const productForm = getProductForm();
  const productPrice = _cachedProductPrice;
  const compareAtPrice = _cachedCompareAtPrice;
  
  // REMOVED: Early capture of original button state
  // Original HTML capture is now handled by veluna-add-to-cart.js AFTER price injection completes
  // This ensures the captured HTML includes data-atc-label and price spans
  
  // Subscription plan mappings
  const subscriptionPlans = {
    '1': { plan: '1_month', frequency: '1', discount: '15', label: '1 Month Delivery' },
    '3': { plan: '3_month', frequency: '3', discount: '20', label: '3 Month Delivery' },
    '6': { plan: '6_month', frequency: '6', discount: '25', label: '6 Month Delivery' }
  };

  function getPackVariantMap() {
    try {
      const el = document.querySelector('[data-veluna-pack-variant-map]');
      if (!el) return null;
      const raw = (el.textContent || '').trim();
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function setQuantityLocked(isLocked) {
    const quantityInput = document.querySelector('#product-quantity');
    const qtyDec = document.querySelector('[data-quantity-decrease]');
    const qtyInc = document.querySelector('[data-quantity-increase]');
    const qtyWrap = document.querySelector('[data-veluna-qty]');

    // Quantity should be usable in BOTH purchase modes.
    // When subscription cadence selects a pack variant, quantity represents number of packs.
    if (quantityInput) {
      quantityInput.disabled = false;
    }
    if (qtyDec) qtyDec.disabled = false;
    if (qtyInc) qtyInc.disabled = false;
    if (qtyWrap) {
      qtyWrap.setAttribute('aria-disabled', 'false');
      qtyWrap.style.display = '';
      qtyWrap.setAttribute('aria-hidden', 'false');
    }
  }

  function setupQuantityStepperHandlers() {
    const form = getProductForm();
    if (!form) return;

    const qtyInput = document.querySelector('#product-quantity');
    const qtyDec = document.querySelector('[data-quantity-decrease]');
    const qtyInc = document.querySelector('[data-quantity-increase]');
    if (!qtyInput || !qtyDec || !qtyInc) return;

    function getPurchaseType() {
      const r = document.querySelector('[data-velunasub-purchase-type]:checked');
      return r && r.value ? String(r.value) : '';
    }

    function getRadioBoundsIfOnetime() {
      if (getPurchaseType() !== 'onetime') return null;
      const radios = Array.from(document.querySelectorAll('[data-velunasub-onetime-qty]'));
      const values = radios.map(r => parseInt(r.value, 10)).filter(n => Number.isFinite(n));
      if (!values.length) return null;
      return { min: Math.min.apply(null, values), max: Math.max.apply(null, values), radios };
    }

    function clamp(n, min, max) {
      return Math.max(min, Math.min(max, n));
    }

    function setQuantity(nextQty) {
      const inputMin = parseInt(qtyInput.getAttribute('min') || '1', 10);
      const inputMaxRaw = qtyInput.getAttribute('max');
      const inputMax = inputMaxRaw ? parseInt(inputMaxRaw, 10) : 10;


      // Update hidden real qty = serving_count × multiplier
      function updateRealQty() {
        var realQtyInput = document.getElementById('veluna-real-qty');
        if (!realQtyInput) return;
        var servingRadio = document.querySelector('[data-velunasub-onetime-qty]:checked');
        var servingCount = servingRadio ? parseInt(servingRadio.value, 10) || 1 : 1;
        var multiplier = parseInt(qtyInput.value, 10) || 1;
        var purchaseType = document.querySelector('[data-velunasub-purchase-type]:checked');
        var isOnetime = purchaseType && purchaseType.value === 'onetime';
        if (isOnetime) {
          // For one-time, qty = serving count (multiplier ignored for simplicity)
          realQtyInput.value = String(servingCount);
        } else {
          realQtyInput.value = String(multiplier);
        }
      }

      // Stepper is a multiplier (1-10), decoupled from serving selection
      const min = Number.isFinite(inputMin) ? inputMin : 1;
      const max = Number.isFinite(inputMax) ? inputMax : 10;
      
      const finalQty = clamp(parseInt(nextQty, 10) || 1, min, max);
      qtyInput.value = String(finalQty);

      // Update hidden form qty (serving_count × multiplier)
      updateRealQty();

      // Re-sync pricing/ATC label after multiplier changes
      syncPurchaseTypeUIAndATC();
    }

    qtyDec.addEventListener('click', function(e) {
      e.preventDefault();
      setQuantity((parseInt(qtyInput.value, 10) || 1) - 1);
    });
    qtyInc.addEventListener('click', function(e) {
      e.preventDefault();
      setQuantity((parseInt(qtyInput.value, 10) || 1) + 1);
    });

    qtyInput.addEventListener('change', function() {
      setQuantity(qtyInput.value);
    });
  }

  function applyPackVariantForCadence(cadence) {
    const form = getProductForm();
    if (!form) return;

    const packMap = getPackVariantMap() || {};
    const entry = packMap && packMap[String(cadence)] ? packMap[String(cadence)] : null;
    const variantId = entry && entry.id ? String(entry.id) : null;
    const priceCents = entry && entry.price_cents ? Number(entry.price_cents) : null;

    // If the pack variants don't exist yet, do not break the PDP
    if (!variantId || variantId === '0') {
      return;
    }

    const idInput = form.querySelector('input[name="id"]');
    const idMirror = document.getElementById('product-variant-id');
    if (idInput) idInput.value = variantId;
    if (idMirror) idMirror.value = variantId;

    form.setAttribute('data-variant-id', variantId);
    form.dataset.variantId = variantId;

    if (typeof priceCents === 'number' && !Number.isNaN(priceCents) && priceCents > 0) {
      form.dataset.price = String(priceCents);
      _cachedProductPrice = priceCents / 100;
    }
  }
  
  // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - Centralized sync function for purchase type UI and ATC text
  // This function is idempotent and safe to call repeatedly
  // Re-queries DOM elements each time to handle Theme Editor rerenders
  function syncPurchaseTypeUIAndATC() {
    // Re-query all elements (no caching to handle Theme Editor rerenders)
    const form = getProductForm();
    if (!form) {
      if (window.VELUNA_DEBUG || window.VELUNA_ATC_DEBUG) {
        console.warn('[RECOVERY_CREAM_SYNC] Form not found, skipping sync');
      }
      return;
    }
    
    const purchaseTypeRadio = document.querySelector('[data-velunasub-purchase-type]:checked');
    const scheduleSection = document.querySelector('[data-velunasub-schedule]');
    const onetimeSection = document.querySelector('[data-velunasub-onetime]');
    const addToCartBtn = document.querySelector('#recovery-cream-add-to-cart');
    const bonusSection = document.querySelector('[data-velunasub-bonus]');
    
    if (!purchaseTypeRadio || !scheduleSection || !onetimeSection || !addToCartBtn) {
      if (window.VELUNA_DEBUG || window.VELUNA_ATC_DEBUG) {
        console.warn('[RECOVERY_CREAM_SYNC] Required elements not found:', {
          purchaseTypeRadio: !!purchaseTypeRadio,
          scheduleSection: !!scheduleSection,
          onetimeSection: !!onetimeSection,
          addToCartBtn: !!addToCartBtn
        });
      }
      return;
    }
    
    // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - Derive current state with fallback logic
    // NEVER default to subscribe if no radio is checked - derive from form state
    let purchaseType = null;
    let isSubscription = false;
    
    if (purchaseTypeRadio) {
      // Primary: use checked radio
      purchaseType = purchaseTypeRadio.value;
      isSubscription = purchaseType === 'subscribe';
    } else {
      // Fallback 1: Check form data attribute (persisted state)
      const persistedType = form.getAttribute('data-veluna-purchase-type');
      if (persistedType === 'subscribe' || persistedType === 'onetime') {
        purchaseType = persistedType;
        isSubscription = persistedType === 'subscribe';
        if (window.VELUNA_RC_DEBUG) {
          console.log('[RECOVERY_CREAM_SYNC] No checked radio, using persisted state:', purchaseType);
        }
      } else {
        // Fallback 2: Derive from selling_plan input state
        const planInput = form.querySelector('[data-velunasub-plan]');
        const hasSellingPlan = planInput && planInput.value !== '' && !planInput.disabled;
        if (hasSellingPlan) {
          purchaseType = 'subscribe';
          isSubscription = true;
          if (window.VELUNA_RC_DEBUG) {
            console.log('[RECOVERY_CREAM_SYNC] No checked radio, derived from selling_plan input: subscribe');
          }
        } else {
          // Fallback 3: Default to onetime (safer than subscribe)
          purchaseType = 'onetime';
          isSubscription = false;
          if (window.VELUNA_RC_DEBUG) {
            console.warn('[RECOVERY_CREAM_SYNC] No checked radio and no form state, defaulting to onetime (safe default)');
          }
        }
      }
    }
    
    // Get selected selling plan (frequency) if subscription
    let selectedSellingPlanId = null;
    if (isSubscription) {
      const frequencyRadio = document.querySelector('[data-velunasub-frequency]:checked');
      selectedSellingPlanId = frequencyRadio ? frequencyRadio.value : null;
    }

    // Prepay bundle subscription: cadence selects pack variant; quantity resets to 1
    if (isSubscription) {
      applyPackVariantForCadence(selectedSellingPlanId || '6');
      // Reset qty to 1 when entering subscribe mode (subscribe price is per-pack, not per-unit)
      const qtyInputSub = document.querySelector('#product-quantity');
      if (qtyInputSub) qtyInputSub.value = '1';
      var realQtyOnSub = document.getElementById('veluna-real-qty');
      if (realQtyOnSub) realQtyOnSub.value = '1';
      setQuantityLocked(true);
    } else {
      // One-time purchase: always use 1-month variant with qty = bottle count
      // Shopify automatic discount handles the volume pricing at checkout
      var checkedOnetimeQty = document.querySelector('[data-velunasub-onetime-qty]:checked');
      var bottles = checkedOnetimeQty ? parseInt(checkedOnetimeQty.value, 10) : 1;
      applyPackVariantForCadence('1');
      setQuantityLocked(false);
    }
    
    // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - Forensic logging with sync run ID
    const syncRunId = (window.__VELUNA_RC_SYNC_RUN_ID__ = (window.__VELUNA_RC_SYNC_RUN_ID__ || 0) + 1);
    const callStack = new Error().stack.split('\n').slice(2, 6).map(line => line.trim()).join(' → ');
    
    // Debug logging (VELUNA_RC_DEBUG for purchase type specific debugging)
    if (window.VELUNA_DEBUG || window.VELUNA_ATC_DEBUG || window.VELUNA_RC_DEBUG) {
      const checkedRadios = Array.from(document.querySelectorAll('[data-velunasub-purchase-type]')).map(r => ({
        value: r.value,
        checked: r.checked
      }));
      const sellingPlanRadios = Array.from(scheduleSection.querySelectorAll('input[type="radio"][data-velunasub-frequency]')).map(r => ({
        value: r.value,
        checked: r.checked,
        disabled: r.disabled
      }));
      
      console.log(`[RECOVERY_CREAM_SYNC] Sync run #${syncRunId} - BEFORE`, {
        purchaseType: purchaseType,
        isSubscription: isSubscription,
        selectedSellingPlanId: selectedSellingPlanId,
        checkedPurchaseTypeRadios: checkedRadios,
        sellingPlanRadios: sellingPlanRadios,
        scheduleDisplay: scheduleSection.style.display,
        scheduleVisibility: scheduleSection.style.visibility,
        scheduleHidden: scheduleSection.hasAttribute('hidden'),
        atcPriceText: addToCartBtn.querySelector('[data-cta-price]') ? addToCartBtn.querySelector('[data-cta-price]').textContent.trim() : 'N/A',
        callStack: callStack
      });
    }
    
    // Trace log for visibility changes (VELUNA_RC_DEBUG)
    if (window.VELUNA_RC_DEBUG) {
      console.log('[RECOVERY_CREAM_SYNC] Setting schedule visibility:', {
        isSubscription: isSubscription,
        willBeVisible: isSubscription,
        currentDisplay: scheduleSection.style.display
      });
    }
    
    // Update UI visibility
    if (isSubscription) {
      // Subscribe: show schedule, hide onetime
      scheduleSection.style.display = 'block';
      scheduleSection.style.visibility = 'visible';
      scheduleSection.removeAttribute('hidden');
      scheduleSection.setAttribute('aria-hidden', 'false');
      
      // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - Enable selling plan radios for Subscribe
      const sellingPlanRadios = scheduleSection.querySelectorAll('input[type="radio"][data-velunasub-frequency], input[type="radio"][name*="selling"]');
      sellingPlanRadios.forEach(radio => {
        radio.disabled = false;
        radio.removeAttribute('aria-disabled');
      });
      
      onetimeSection.style.display = 'none';
      onetimeSection.style.visibility = 'hidden';
      onetimeSection.setAttribute('hidden', '');
      onetimeSection.setAttribute('aria-hidden', 'true');

      // Show subscriber bonus stack (reciprocity + exclusivity)
      if (bonusSection) {
        bonusSection.style.display = 'block';
        bonusSection.removeAttribute('hidden');
        bonusSection.setAttribute('aria-hidden', 'false');
      }
      
      if (window.VELUNA_RC_DEBUG) {
        console.log('[RECOVERY_CREAM_SYNC] Schedule visibility set: display=block, visibility=visible, hidden=false, aria-hidden=false');
        console.log('[RECOVERY_CREAM_SYNC] Enabled selling plan radios:', sellingPlanRadios.length);
      }
      
      // Update selected state on labels
      document.querySelectorAll('[data-velunasub-purchase-type]').forEach(radio => {
        const label = radio.closest('label');
        if (label) {
          if (radio.checked) {
            label.classList.add('selected');
          } else {
            label.classList.remove('selected');
          }
        }
      });
      
      // Set and ENABLE selling plan inputs if frequency is selected
      if (selectedSellingPlanId) {
        const plan = subscriptionPlans[selectedSellingPlanId];
        if (plan) {
          const planInput = form.querySelector('[data-velunasub-plan]');
          const frequencyInput = form.querySelector('[data-velunasub-frequency-input]');
          const discountInput = form.querySelector('[data-velunasub-discount]');
          
          if (planInput) {
            planInput.value = plan.plan;
            planInput.disabled = false; // Enable for submission
            planInput.removeAttribute('data-veluna-disabled');
          }
          if (frequencyInput) {
            frequencyInput.value = plan.frequency;
            frequencyInput.disabled = false;
            frequencyInput.removeAttribute('data-veluna-disabled');
          }
          if (discountInput) {
            discountInput.value = plan.discount;
            discountInput.disabled = false;
            discountInput.removeAttribute('data-veluna-disabled');
          }
        }
      }
      
      // Enable any Shopify subscriptions app inputs if they exist
      const sellingPlanInputs = form.querySelectorAll('input[name="selling_plan"], input[name*="selling_plan"]');
      sellingPlanInputs.forEach(input => {
        input.disabled = false;
        input.removeAttribute('data-veluna-disabled');
      });
      
      // Update button class
      addToCartBtn.classList.add('recovery-cream-hero__cta--subscription');
    } else {
      // One Time: hide schedule, show onetime
      scheduleSection.style.display = 'none';
      scheduleSection.style.visibility = 'hidden';
      scheduleSection.setAttribute('hidden', '');
      scheduleSection.setAttribute('aria-hidden', 'true');
      
      // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - Disable all selling plan radios inside schedule
      // This prevents them from being focusable/interactive when schedule is hidden
      const sellingPlanRadios = scheduleSection.querySelectorAll('input[type="radio"][data-velunasub-frequency], input[type="radio"][name*="selling"]');
      sellingPlanRadios.forEach(radio => {
        radio.disabled = true;
        radio.setAttribute('aria-disabled', 'true');
        if (window.VELUNA_RC_DEBUG) {
          console.log('[RECOVERY_CREAM_SYNC] Disabled selling plan radio:', { value: radio.value, wasChecked: radio.checked });
        }
      });
      
      onetimeSection.style.display = 'block';
      onetimeSection.style.visibility = 'visible';
      onetimeSection.removeAttribute('hidden');
      onetimeSection.setAttribute('aria-hidden', 'false');

      // Hide subscriber bonus stack on one-time selection
      if (bonusSection) {
        bonusSection.style.display = 'none';
        bonusSection.setAttribute('hidden', '');
        bonusSection.setAttribute('aria-hidden', 'true');
      }
      
      if (window.VELUNA_RC_DEBUG) {
        console.log('[RECOVERY_CREAM_SYNC] Schedule visibility set: display=none, visibility=hidden, hidden=true, aria-hidden=true');
        console.log('[RECOVERY_CREAM_SYNC] Disabled selling plan radios:', sellingPlanRadios.length);
      }
      
      // Update selected state on labels
      document.querySelectorAll('[data-velunasub-purchase-type]').forEach(radio => {
        const label = radio.closest('label');
        if (label) {
          if (radio.checked) {
            label.classList.add('selected');
          } else {
            label.classList.remove('selected');
          }
        }
      });
      
      // Clear and DISABLE selling plan inputs (prevent submission)
      const planInput = form.querySelector('[data-velunasub-plan]');
      const frequencyInput = form.querySelector('[data-velunasub-frequency-input]');
      const discountInput = form.querySelector('[data-velunasub-discount]');
      
      if (planInput) {
        planInput.value = '';
        planInput.disabled = true; // Prevent form submission
        planInput.setAttribute('data-veluna-disabled', 'true');
      }
      if (frequencyInput) {
        frequencyInput.value = '';
        frequencyInput.disabled = true;
        frequencyInput.setAttribute('data-veluna-disabled', 'true');
      }
      if (discountInput) {
        discountInput.value = '';
        discountInput.disabled = true;
        discountInput.setAttribute('data-veluna-disabled', 'true');
      }
      
      // Also check for any Shopify subscriptions app inputs (name="selling_plan")
      const sellingPlanInputs = form.querySelectorAll('input[name="selling_plan"], input[name*="selling_plan"]');
      sellingPlanInputs.forEach(input => {
        input.disabled = true;
        input.setAttribute('data-veluna-disabled', 'true');
      });
      
      // Update hidden form qty = serving_count × multiplier (stepper stays unchanged)
      var onetimeQtyRadio = document.querySelector('[data-velunasub-onetime-qty]:checked');
      if (onetimeQtyRadio) {
        var onetimeServings = parseInt(onetimeQtyRadio.value, 10) || 1;
        var realQtyInput = document.getElementById('veluna-real-qty');
        var multiplierInput = document.querySelector('#product-quantity');
        var multiplier = multiplierInput ? parseInt(multiplierInput.value, 10) || 1 : 1;
        if (realQtyInput) {
          // For one-time, qty = serving count (multiplier ignored for simplicity)
          realQtyInput.value = String(onetimeServings);
        }
      }
      
      // Update one-time card prices dynamically
      if (typeof updateOnetimeCardPrices === 'function') updateOnetimeCardPrices();

      // Update button class
      addToCartBtn.classList.remove('recovery-cream-hero__cta--subscription');
    }
    
    // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - Runtime assertions and post-close verifier
    if (window.VELUNA_DEBUG || window.VELUNA_ATC_DEBUG || window.VELUNA_RC_DEBUG) {
      const scheduleIsVisible = scheduleSection.style.display !== 'none' && scheduleSection.style.visibility !== 'hidden';
      const sellingPlanInput = form.querySelector('[data-velunasub-plan]');
      const hasSellingPlan = sellingPlanInput && sellingPlanInput.value !== '';
      const sellingPlanDisabled = sellingPlanInput ? sellingPlanInput.disabled : false;
      
      // Assertion: One Time should hide schedule and disable selling plan
      if (!isSubscription && scheduleIsVisible) {
        console.error('[RECOVERY_CREAM_SYNC] ASSERTION FAILED: purchaseType=onetime but schedule container is visible', {
          display: scheduleSection.style.display,
          visibility: scheduleSection.style.visibility,
          hidden: scheduleSection.hasAttribute('hidden')
        });
      }
      if (!isSubscription && hasSellingPlan) {
        console.error('[RECOVERY_CREAM_SYNC] ASSERTION FAILED: purchaseType=onetime but selling_plan input is set:', sellingPlanInput.value);
      }
      if (!isSubscription && !sellingPlanDisabled) {
        console.error('[RECOVERY_CREAM_SYNC] ASSERTION FAILED: purchaseType=onetime but selling_plan input is not disabled');
      }
      
      // Assertion: Subscribe should show schedule and enable selling plan
      if (isSubscription && !scheduleIsVisible) {
        console.error('[RECOVERY_CREAM_SYNC] ASSERTION FAILED: purchaseType=subscribe but schedule container is hidden', {
          display: scheduleSection.style.display,
          visibility: scheduleSection.style.visibility
        });
      }
      
      // Log state after sync for forensic analysis
      if (window.VELUNA_RC_DEBUG) {
        console.log('[RECOVERY_CREAM_SYNC] Post-sync state:', {
          purchaseType: purchaseType,
          isSubscription: isSubscription,
          scheduleVisible: scheduleIsVisible,
          sellingPlanValue: sellingPlanInput ? sellingPlanInput.value : 'N/A',
          sellingPlanDisabled: sellingPlanDisabled,
          atcPriceText: addToCartBtn.querySelector('[data-cta-price]') ? addToCartBtn.querySelector('[data-cta-price]').textContent.trim() : 'N/A'
        });
      }
    }
    
    // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - Update ATC button text (deterministic, use requestAnimationFrame for DOM consistency)
    // CRITICAL: Only update text content, NOT disabled/clickable state
    // Use double RAF to ensure DOM updates are complete
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // Only update text spans, not button state
        const priceSpan = addToCartBtn.querySelector('[data-cta-price], .recovery-cream-hero__cta-price');
        const labelSpan = addToCartBtn.querySelector('[data-atc-label], .recovery-cream-hero__cta-text');
        
        if (priceSpan) {
          // Update price text based on purchase type
          updateAddToCartPrice();
        } else if (window.VELUNA_RC_DEBUG) {
          console.warn('[RECOVERY_CREAM_SYNC] Price span not found, cannot update ATC text');
        }
        
        if (window.VELUNA_RC_DEBUG) {
          const finalPriceSpan = addToCartBtn.querySelector('[data-cta-price], .recovery-cream-hero__cta-price');
          const finalLabelSpan = addToCartBtn.querySelector('[data-atc-label], .recovery-cream-hero__cta-text');
          console.log('[RECOVERY_CREAM_SYNC] ATC text updated:', {
            priceText: finalPriceSpan ? finalPriceSpan.textContent.trim() : 'N/A',
            labelText: finalLabelSpan ? finalLabelSpan.textContent.trim() : 'N/A',
            purchaseType: purchaseType,
            buttonDisabled: addToCartBtn.disabled,
            buttonClickable: !addToCartBtn.disabled && addToCartBtn.style.pointerEvents !== 'none'
          });
        }
      });
    });
    
    // Debug logging after ATC update
    if (window.VELUNA_DEBUG || window.VELUNA_ATC_DEBUG) {
      const priceSpan = addToCartBtn.querySelector('[data-cta-price], .recovery-cream-hero__cta-price');
      const labelSpan = addToCartBtn.querySelector('[data-atc-label], .recovery-cream-hero__cta-text');
      console.log('[RECOVERY_CREAM_SYNC] ATC text after sync:', {
        labelText: labelSpan ? labelSpan.textContent : 'N/A',
        priceText: priceSpan ? priceSpan.textContent : 'N/A'
      });
    }
  }
  
  // Expose sync function globally for Theme Editor and external calls
  window.syncPurchaseTypeUIAndATC = syncPurchaseTypeUIAndATC;
  
  // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - Expose stable sync function for cart drawer
  // This is called after drawer close to re-sync main ATC text with current purchase type state
  // Must be idempotent and safe if elements missing
  window.VELUNA_RC_SYNC_ATC = function(reason) {
    if (window.VELUNA_RC_DEBUG) {
      console.log('[RECOVERY_CREAM] VELUNA_RC_SYNC_ATC called', { reason: reason || 'unknown' });
    }
    try {
      syncPurchaseTypeUIAndATC();
    } catch (e) {
      if (window.VELUNA_RC_DEBUG || window.VELUNA_DEBUG) {
        console.warn('[RECOVERY_CREAM] Error in VELUNA_RC_SYNC_ATC:', e);
      }
    }
  };
  
  // Update savings amounts - calculate actual savings from compare_at_price - price
  // This function runs on page load to ensure prices are correct
  async function updateSavingsAmounts() {
    // Re-query form and price (handle Theme Editor rerenders)
    const form = getProductForm();
    const currentPrice = _cachedProductPrice;
    const currentCompareAtPrice = _cachedCompareAtPrice;
    
    // Log for debugging
    console.log('[RECOVERY_CREAM] Price update:', { productPrice: currentPrice, compareAtPrice: currentCompareAtPrice, form: form ? 'found' : 'not found' });
    
    // IMPORTANT: The PDP schedule cards represent *different cadences* (1/3/6 months).
    // We must compute savings per cadence (based on the plan's discount), not a single
    // compare_at_price - price delta applied to every option.
    if (!(currentPrice > 0)) {
      if (window.VELUNA_DEBUG || window.VELUNA_ATC_DEBUG) {
        console.log('[RECOVERY_CREAM] No base price available for savings');
      }
      const subscriptionRadios = document.querySelectorAll('[data-velunasub-frequency]');
      subscriptionRadios.forEach(radio => {
        const saveBadge = radio.closest('label')?.querySelector('[data-save-amount="' + radio.value + '"]');
        if (saveBadge) saveBadge.style.display = 'none';
      });
      return;
    }

    const subscriptionRadios = document.querySelectorAll('[data-velunasub-frequency]');
    subscriptionRadios.forEach(radio => {
      const months = parseInt(String(radio.value || ''), 10);
      const plan = subscriptionPlans[String(radio.value)];
      const discountPct = plan && plan.discount != null ? parseFloat(plan.discount) : NaN;
      const saveBadge = radio.closest('label')?.querySelector('[data-save-amount="' + radio.value + '"]');
      const savingsCalc = saveBadge ? saveBadge.querySelector('[data-save-calc="' + radio.value + '"]') : null;

      if (!saveBadge || !isFinite(discountPct) || discountPct <= 0) {
        if (saveBadge) saveBadge.style.display = 'none';
        return;
      }

      const discountedPerMonth = currentPrice * (1 - (discountPct / 100));
      const perMonthSavings = currentPrice - discountedPerMonth;
      const cadence = (isFinite(months) && months > 1) ? months : 1;
      const totalSavings = perMonthSavings * cadence;

      if (totalSavings > 0.005) {
        // Update the visible text (keep the hidden calc span intact)
        const saveText = saveBadge.childNodes[0];
        if (saveText && saveText.nodeType === 3) {
          saveText.textContent = 'Save $' + totalSavings.toFixed(2);
        }
        if (savingsCalc) {
          savingsCalc.textContent = totalSavings.toFixed(2);
        }
        saveBadge.style.display = '';
      } else {
        saveBadge.style.display = 'none';
      }
    });

    // One-time purchase savings: 3 Sets = 25% off, 2 Sets = 15% off.
    // Keep this dynamic so it stays correct if the base price changes.
    const onetimeRadios = document.querySelectorAll('[data-velunasub-onetime-qty]');
    onetimeRadios.forEach(radio => {
      const qty = parseInt(String(radio.value || ''), 10);
      if (!isFinite(qty) || qty <= 0) return;

      const key = 'onetime-' + String(qty);
      const label = radio.closest('label');
      if (!label) return;

      // Locate the badge either by data-save-amount or by the hidden calc span.
      const calcEl = label.querySelector('[data-save-calc="' + key + '"]');
      const badge = label.querySelector('[data-save-amount="' + key + '"]')
        || (calcEl ? calcEl.closest('[data-veluna-plan-save]') : null);
      if (!badge) return;

      // One-time volume discounts: 3 bottles = 20% off, 2 bottles = 10% off
      // Always use unit price (1-month), not the currently selected variant price
      var unitPriceForSavings = (_unitPrice > 0) ? _unitPrice : currentPrice;
      const discount = (qty === 3) ? 0.20 : (qty === 2) ? 0.10 : 0;
      const compareTotal = unitPriceForSavings * qty;
      const discountedTotal = compareTotal * (1 - discount);
      const savings = compareTotal - discountedTotal;

      if (savings > 0.005) {
        if (calcEl) calcEl.textContent = savings.toFixed(2);

        // Update the visible text while preserving nested spans if present.
        const textNode = badge.childNodes && badge.childNodes.length ? badge.childNodes[0] : null;
        if (textNode && textNode.nodeType === 3) {
          textNode.textContent = 'Save $' + savings.toFixed(2);
        } else if (!calcEl) {
          badge.textContent = 'Save $' + savings.toFixed(2);
        }

        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    });
  }
  
  // Cache last known cart item count to avoid unnecessary /cart.js fetches
  var _lastKnownCartItemCount = null;
  
  // Expose cache update function for veluna-add-to-cart.js to call after successful add
  // HARDENED: Only accept valid finite numbers >= 0
  window.updateCartItemCountCache = function(itemCount) {
    var count = Number(itemCount);
    if (isFinite(count) && count >= 0) {
      _lastKnownCartItemCount = count;
    } else {
      console.warn('[RECOVERY_CREAM] Invalid cart item count for cache:', itemCount);
    }
  };
  
  // Update cart attributes via Shopify Cart API (refactored to async/await)
  // Uses global cart mutex to prevent concurrent mutations with /cart/add.js
  // GATED: Only updates if cart has items (prevents Clear-Site-Data side effects)
  async function updateCartAttributes(plan) {
    try {
      // Use cached item_count if available, only fetch if unknown
      var cartItemCount = _lastKnownCartItemCount;
      if (cartItemCount === null) {
        var cartCheck = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
        cartItemCount = cartCheck ? cartCheck.item_count : 0;
        _lastKnownCartItemCount = cartItemCount;
      }
      
      if (cartItemCount === 0) {
        // Cart is empty - don't update attributes (prevents Clear-Site-Data)
        return;
      }
      
      // Use cart mutex if available (from veluna-add-to-cart.js), otherwise direct fetch
      var mutex = window.__VELUNA_CART_MUTEX__;
      var fetchPromise = function() {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'subscription_plan': plan.plan,
              'subscription_frequency': plan.frequency,
              'subscription_discount': plan.discount
            }
          })
        }).then(function(response) {
          return response.json();
        });
      };
      
      var cartPromise = mutex ? mutex.enqueue(fetchPromise) : fetchPromise();
      const cart = await cartPromise;
      
      console.log('✅ VelunaSub cart attributes updated:', {
        subscription_plan: plan.plan,
        subscription_frequency: plan.frequency,
        subscription_discount: plan.discount
      });
      
      // Update cached item count if we got cart data back
      if (cart && typeof cart.item_count === 'number') {
        _lastKnownCartItemCount = cart.item_count;
      }
    } catch (error) {
      console.warn('⚠️ Could not update cart attributes (cart may be empty):', error);
    }
  }
  
  // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - Purchase type change handler using event delegation
  // Use event delegation on a stable parent container to handle Theme Editor rerenders
  function setupPurchaseTypeHandlers() {
    const form = getProductForm();
    if (!form) return;
    
    // Use event delegation on the form (stable parent)
    form.addEventListener('change', function(e) {
      // Check if this is a purchase type radio change
      if (e.target && e.target.hasAttribute('data-velunasub-purchase-type')) {
        try {
          // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - Persist purchase type state to form
          // This allows recovery after drawer close if DOM is reconstructed
          const purchaseType = e.target.value;
          form.setAttribute('data-veluna-purchase-type', purchaseType);
          
          if (window.VELUNA_RC_DEBUG) {
            console.log('[RECOVERY_CREAM] Purchase type changed, persisting state:', {
              purchaseType: purchaseType,
              persisted: form.getAttribute('data-veluna-purchase-type')
            });
          }
          
          // Reset any temporary button labels (Added!, In Cart, etc.) when purchase type changes
          const addToCartBtn = document.querySelector('#recovery-cream-add-to-cart');
          if (addToCartBtn && window.VelunaAddToCart && typeof window.VelunaAddToCart.resetButtonTemporaryLabel === 'function') {
            window.VelunaAddToCart.resetButtonTemporaryLabel(addToCartBtn);
          }
          
          // Sync UI and ATC text (centralized function handles everything)
          syncPurchaseTypeUIAndATC();
          
          // Clear cart attributes for one-time purchase (only if cart has items)
          const purchaseTypeRadio = document.querySelector('[data-velunasub-purchase-type]:checked');
          const isSubscription = purchaseTypeRadio && purchaseTypeRadio.value === 'subscribe';
          
          if (!isSubscription) {
            // One-time purchase: clear cart attributes (only if cart has items)
            (async function() {
              try {
                var cartItemCount = _lastKnownCartItemCount;
                if (cartItemCount === null) {
                  var cartCheck = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
                  cartItemCount = cartCheck ? cartCheck.item_count : 0;
                  _lastKnownCartItemCount = cartItemCount;
                }
                
                if (cartItemCount > 0) {
                  var mutex = window.__VELUNA_CART_MUTEX__;
                  var fetchPromise = function() {
                    return fetch('/cart/update.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        attributes: {
                          'subscription_plan': '',
                          'subscription_frequency': '',
                          'subscription_discount': ''
                        }
                      })
                    });
                  };
                  await (mutex ? mutex.enqueue(fetchPromise) : fetchPromise());
                }
              } catch (e) {
                // Silently fail if cart is empty or not available
              }
            })();
          }
        } catch(e) {
          console.warn('VelunaSub: Error updating purchase type', e);
        }
      }
    });
    
    // Initialize selected state on labels
    const purchaseTypeRadios = document.querySelectorAll('[data-velunasub-purchase-type]');
    purchaseTypeRadios.forEach(radio => {
      if (radio.checked) {
        const label = radio.closest('label');
        if (label) {
          label.classList.add('selected');
        }
      }
    });
  }
  
  // Setup purchase type handlers on load
  setupPurchaseTypeHandlers();
  
  // VELUNA_PROOF_CRITICAL_FIX_2026-01-01T08:45:00Z - Update price block based on purchase type and frequency
  // Calculate monthly price from actual product price and selected frequency
  function updatePriceBlockForFrequency() {
    const priceBlock = document.querySelector('.recovery-cream-hero__price-block');
    const priceText = priceBlock ? priceBlock.querySelector('[data-price-text]') : null;
    // Price block is hidden, but we still need to update it for data attributes
    // Return early if priceText doesn't exist (it's hidden anyway)
    if (!priceBlock) return;
    
    const purchaseTypeRadio = document.querySelector('[data-velunasub-purchase-type]:checked');
    const isSubscription = purchaseTypeRadio && purchaseTypeRadio.value === 'subscribe';

    const qtyInput = document.querySelector('#product-quantity');
    const qty = Math.max(1, parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10) || 1);
    
    if (isSubscription) {
      // Subscription: read per-month rate directly from the selected schedule card.
      const frequencyRadio = document.querySelector('[data-velunasub-frequency]:checked');
      const selectedCard = frequencyRadio ? frequencyRadio.closest('label') : null;
      const cardPriceSpan = selectedCard ? selectedCard.querySelector('.recovery-cream-hero__schedule-price') : null;
      let perMonthBase = 0;
      if (cardPriceSpan) {
        perMonthBase = parseFloat(cardPriceSpan.textContent.replace(/[^0-9.]/g, '')) || 0;
      }
      if (perMonthBase <= 0) {
        // Fallback: cached price / frequency
        const form = getProductForm();
        const packTotal = (_cachedProductPrice && _cachedProductPrice > 0)
          ? _cachedProductPrice
          : (form && form.dataset.price ? (parseInt(form.dataset.price, 10) || 0) / 100.0 : 0);
        const frequency = frequencyRadio ? parseInt(frequencyRadio.value, 10) : 6;
        perMonthBase = packTotal / Math.max(1, frequency);
      }
      if (priceText) {
        const perMonth = perMonthBase * qty;
        priceText.textContent = '$' + perMonth.toFixed(2) + '/month';
      }
    } else {
      // One-time purchase: show price based on quantity input
      const onetimePriceCents = parseInt(priceBlock.dataset.priceOnetimeCents || 0);
      const onetimePrice = onetimePriceCents / 100.0;
      
      if (priceText) {
        // One-time volume discount using unit price
        var unitPB = (_unitPrice > 0) ? _unitPrice : (onetimePrice > 0 ? onetimePrice : 0);
        if (unitPB > 0) {
          const disc = (qty >= 3) ? 0.20 : (qty === 2) ? 0.10 : 0;
          const total = (unitPB * qty) * (1 - disc);
          priceText.textContent = '$' + total.toFixed(2);
        }
      }
    }
  }
  
  // Update Add To Cart button price based on purchase type and selection
  // Expose globally so cart drawer can call it
  function updateAddToCartPrice() {
    // Re-query button and price (handle Theme Editor rerenders)
    const btn = document.querySelector('#recovery-cream-add-to-cart');
    const form = getProductForm();
    const currentPrice = _cachedProductPrice;
    
    if (!btn || !currentPrice) {
      if (window.VELUNA_DEBUG || window.VELUNA_ATC_DEBUG) {
        console.warn('[RECOVERY_CREAM] updateAddToCartPrice: button or price not found', {
          btn: !!btn,
          price: currentPrice
        });
      }
      return;
    }
    
    const purchaseTypeRadio = document.querySelector('[data-velunasub-purchase-type]:checked');
    const isSubscription = purchaseTypeRadio && purchaseTypeRadio.value === 'subscribe';

    const qtyInput = document.querySelector('#product-quantity');
    const qty = Math.max(1, parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10) || 1);
    
    const priceSpan = btn.querySelector('[data-cta-price], .recovery-cream-hero__cta-price');
    const compareSpan = btn.querySelector('.recovery-cream-hero__cta-compare-price');
    
    if (!priceSpan) {
      if (window.VELUNA_DEBUG || window.VELUNA_ATC_DEBUG) {
        console.warn('[RECOVERY_CREAM] updateAddToCartPrice: price span not found in button');
      }
      return;
    }
    
    if (isSubscription) {
      // Subscription: read the per-month rate directly from the selected schedule card.
      // This guarantees ATC price always matches the displayed card price.
      const frequencyRadio = document.querySelector('[data-velunasub-frequency]:checked');
      const selectedCard = frequencyRadio ? frequencyRadio.closest('label') : null;
      const cardPriceSpan = selectedCard ? selectedCard.querySelector('.recovery-cream-hero__schedule-price') : null;
      let perMonthBase = 0;
      if (cardPriceSpan) {
        // Text is like "$96.75/month" — strip non-numeric except period
        perMonthBase = parseFloat(cardPriceSpan.textContent.replace(/[^0-9.]/g, '')) || 0;
      }
      if (perMonthBase <= 0) {
        // Fallback: derive from cached price
        const frequency = frequencyRadio ? parseInt(frequencyRadio.value) : 6;
        perMonthBase = currentPrice / Math.max(1, frequency);
      }
      const perMonth = perMonthBase * qty;
      priceSpan.textContent = '$' + perMonth.toFixed(2) + '/month';
      if (compareSpan) compareSpan.style.display = 'none';
    } else {
      // One-time purchase: show price based on quantity input
      
      let totalPrice;
      let comparePrice;
      
      // Use unit price (1-month) for discount display calculations
      var onetimeQty = document.querySelector('[data-velunasub-onetime-qty]:checked');
      var onetimeBottles = onetimeQty ? parseInt(onetimeQty.value, 10) : qty;
      var unitPriceForATC = (_unitPrice > 0) ? _unitPrice : currentPrice;
      
      // Volume discounts: 3+ = 20% off, 2 = 10% off, 1 = no discount
      var discountRate = (onetimeBottles >= 3) ? 0.20 : (onetimeBottles === 2) ? 0.10 : 0;
      var fullPriceATC = unitPriceForATC * onetimeBottles;
      totalPrice = (fullPriceATC * (1 - discountRate) * qty).toFixed(2);
      comparePrice = (discountRate > 0) ? (fullPriceATC * qty).toFixed(2) : null;
      
      priceSpan.textContent = '$' + totalPrice;
      
      if (compareSpan) {
        if (comparePrice && comparePrice !== totalPrice) {
          compareSpan.textContent = '$' + comparePrice;
          compareSpan.style.display = '';
        } else {
          compareSpan.style.display = 'none';
        }
      }
    }
  }
  
  // Expose updateAddToCartPrice globally so cart drawer can call it
  window.updateAddToCartPrice = updateAddToCartPrice;
  
  // Initialize price block on page load
  function initializePriceBlock() {
    updatePriceBlockForFrequency();
  }
  
  // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - Theme Editor rerender handlers
  // Reinitialize purchase type state when Theme Editor reloads section
  function setupThemeEditorHandlers() {
    // Handle section load (Theme Editor reloads section)
    document.addEventListener('shopify:section:load', function(e) {
      if (e.detail && e.detail.sectionId) {
        const section = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
        if (section && section.querySelector('.recovery-cream-hero__form')) {
          // Reset cached form reference
          _cachedProductForm = null;
          
          // Re-setup handlers
          setupPurchaseTypeHandlers();
          setupFrequencyHandlers();
          setupQuantityHandlers();
          
          // Sync UI state
          setTimeout(function() {
            syncPurchaseTypeUIAndATC();
            updateSavingsAmounts();
          }, 100);
          
          if (window.VELUNA_DEBUG || window.VELUNA_ATC_DEBUG) {
            console.log('[RECOVERY_CREAM] Theme Editor section loaded, reinitialized handlers');
          }
        }
      }
    });
    
    // Handle section select (Theme Editor selects section)
    document.addEventListener('shopify:section:select', function(e) {
      if (e.detail && e.detail.sectionId) {
        const section = document.querySelector('[data-section-id="' + e.detail.sectionId + '"]');
        if (section && section.querySelector('.recovery-cream-hero__form')) {
          // Sync UI state when section is selected
          setTimeout(function() {
            syncPurchaseTypeUIAndATC();
          }, 50);
          
          if (window.VELUNA_DEBUG || window.VELUNA_ATC_DEBUG) {
            console.log('[RECOVERY_CREAM] Theme Editor section selected, synced UI');
          }
        }
      }
    });
  }
  
  // Setup Theme Editor handlers
  setupThemeEditorHandlers();
  
  // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - Listen for cart drawer close to re-sync
  // Re-sync purchase type UI and ATC text after drawer closes
  function setupDrawerCloseHandler() {
    // Listen for custom drawer close event (if veluna-cart-drawer.js emits one)
    document.addEventListener('veluna:cart-drawer:closed', function(e) {
      const closeTxn = e.detail?.closeTxn || 'unknown';
      const closePath = e.detail?.closePath || 'unknown';
      
      if (window.VELUNA_RC_DEBUG) {
        console.log('[RECOVERY_CREAM] Drawer closed event received, re-syncing purchase type UI', {
          closeTxn: closeTxn,
          closePath: closePath,
          timestamp: e.detail?.timestamp || Date.now()
        });
      }
      
      // Use double RAF to ensure drawer cleanup is complete
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - Only update text content, NOT disabled/clickability state
          // Scope to PRIMARY PDP button only (not cross-sell)
          const form = getProductForm();
          if (!form) {
            if (window.VELUNA_RC_DEBUG) {
              console.warn('[RECOVERY_CREAM] Form not found, cannot sync ATC text');
            }
            return;
          }
          
          const addToCartBtn = document.querySelector('#recovery-cream-add-to-cart');
          if (!addToCartBtn) {
            if (window.VELUNA_RC_DEBUG) {
              console.warn('[RECOVERY_CREAM] Main ATC button not found, cannot sync text');
            }
            return;
          }
          
          // Run full sync (updates UI state + ATC text)
          syncPurchaseTypeUIAndATC();
          
          // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - Verify text was updated correctly
          if (window.VELUNA_RC_DEBUG) {
            const priceSpan = addToCartBtn.querySelector('[data-cta-price], .recovery-cream-hero__cta-price');
            const labelSpan = addToCartBtn.querySelector('[data-atc-label], .recovery-cream-hero__cta-text');
            const purchaseTypeRadio = document.querySelector('[data-velunasub-purchase-type]:checked');
            
            console.log('[RECOVERY_CREAM] ATC text synced after drawer close', {
              closeTxn: closeTxn,
              closePath: closePath,
              purchaseType: purchaseTypeRadio ? purchaseTypeRadio.value : 'N/A',
              labelText: labelSpan ? labelSpan.textContent.trim() : 'N/A',
              priceText: priceSpan ? priceSpan.textContent.trim() : 'N/A',
              hasMonth: priceSpan ? priceSpan.textContent.includes('/month') : false,
              buttonDisabled: addToCartBtn.disabled,
              buttonClickable: !addToCartBtn.disabled && addToCartBtn.style.pointerEvents !== 'none'
            });
          }
        });
      });
    });
    
    // Also listen for drawer class changes (fallback)
    const drawer = document.querySelector('[data-veluna-cart-drawer], [data-cart-drawer]');
    if (drawer) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const isOpen = drawer.classList.contains('veluna-cart-drawer--open');
            if (!isOpen) {
              // Drawer just closed, re-sync
              if (window.VELUNA_RC_DEBUG) {
                console.log('[RECOVERY_CREAM] Drawer closed (class change), re-syncing purchase type UI');
              }
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  syncPurchaseTypeUIAndATC();
                });
              });
            }
          }
        });
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }
  
  // Setup drawer close handler
  setupDrawerCloseHandler();
  
  // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - Initialize persisted state on page load
  // If form has persisted state but no checked radio, restore the checked state
  function initializePersistedState() {
    const form = getProductForm();
    if (!form) return;
    
    const persistedType = form.getAttribute('data-veluna-purchase-type');
    if (persistedType) {
      const radio = document.querySelector(`[data-velunasub-purchase-type][value="${persistedType}"]`);
      if (radio && !radio.checked) {
        // Only restore if no radio is currently checked (safe restore)
        const anyChecked = document.querySelector('[data-velunasub-purchase-type]:checked');
        if (!anyChecked) {
          radio.checked = true;
          if (window.VELUNA_RC_DEBUG) {
            console.log('[RECOVERY_CREAM] Restored persisted purchase type:', persistedType);
          }
        }
      }
    }
  }
  
  // Run initialization after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializePersistedState();
      initializePriceBlock();
      // Sync purchase type UI on initial load
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          syncPurchaseTypeUIAndATC();
        });
      });
    });
  } else {
    // DOM already loaded, run immediately
    initializePersistedState();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        initializePriceBlock();
        syncPurchaseTypeUIAndATC();
      });
    });
  }
  
  // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - One-time quantity selection using event delegation
  function setupQuantityHandlers() {
    const form = getProductForm();
    if (!form) return;
    
    // Use event delegation on the form (stable parent)
    form.addEventListener('change', function(e) {
      // Check if this is a one-time quantity radio change
      if (e.target && e.target.hasAttribute('data-velunasub-onetime-qty')) {
        // Reset any temporary button labels when quantity changes
        const addToCartBtn = document.querySelector('#recovery-cream-add-to-cart');
        if (addToCartBtn && window.VelunaAddToCart && typeof window.VelunaAddToCart.resetButtonTemporaryLabel === 'function') {
          window.VelunaAddToCart.resetButtonTemporaryLabel(addToCartBtn);
        }
        
        // Update selected state
        document.querySelectorAll('[data-velunasub-onetime-qty]').forEach(r => {
          const label = r.closest('label');
          if (label) {
            if (r.checked) {
              label.classList.add('selected');
            } else {
              label.classList.remove('selected');
            }
          }
        });
        
        // Serving changed — update hidden form qty (don't touch the stepper)
        var realQty = document.getElementById('veluna-real-qty');
        var multiplierInput = document.querySelector('#product-quantity');
        var multiplier = multiplierInput ? parseInt(multiplierInput.value, 10) || 1 : 1;
        var newServings = parseInt(e.target.value, 10) || 1;
        if (realQty) {
          // For one-time, qty = serving count (multiplier ignored for simplicity)
          realQty.value = String(newServings);
        }
        
        // Sync UI and ATC text (includes price update)
        syncPurchaseTypeUIAndATC();
      }
    });
    
    // Initialize selected state on labels
    const onetimeQuantityRadios = document.querySelectorAll('[data-velunasub-onetime-qty]');
    onetimeQuantityRadios.forEach(radio => {
      if (radio.checked) {
        const label = radio.closest('label');
        if (label) {
          label.classList.add('selected');
        }
      }
    });
  }
  
  // Setup quantity handlers on load
  setupQuantityHandlers();
  setupQuantityStepperHandlers();
  
  // VELUNA_PROOF_CRITICAL_FIX_2026-01-07 - Subscription frequency selection using event delegation
  // DEBOUNCED: Prevent rapid-fire /cart/update.js calls
  var subscriptionChangeTimeout = null;
  
  function setupFrequencyHandlers() {
    const form = getProductForm();
    if (!form) return;
    
    // Use event delegation on the form (stable parent)
    form.addEventListener('change', function(e) {
      // Check if this is a frequency radio change
      if (e.target && e.target.hasAttribute('data-velunasub-frequency')) {
        var radioElement = e.target; // Preserve reference
        // Debounce: clear previous timeout
        if (subscriptionChangeTimeout) {
          clearTimeout(subscriptionChangeTimeout);
        }
        
        // Only update after 300ms of no changes (prevents excessive /cart/update.js calls)
        subscriptionChangeTimeout = setTimeout(function() {
          try {
            // Reset any temporary button labels when frequency changes
            const addToCartBtn = document.querySelector('#recovery-cream-add-to-cart');
            if (addToCartBtn && window.VelunaAddToCart && typeof window.VelunaAddToCart.resetButtonTemporaryLabel === 'function') {
              window.VelunaAddToCart.resetButtonTemporaryLabel(addToCartBtn);
            }
            
            const frequency = radioElement.value;
            const plan = subscriptionPlans[frequency];
            const purchaseTypeChecked = document.querySelector('[data-velunasub-purchase-type]:checked');
            const isSubscription = purchaseTypeChecked && purchaseTypeChecked.value === 'subscribe';
            
            // Update selected state
            document.querySelectorAll('[data-velunasub-frequency]').forEach(r => {
              const label = r.closest('label');
              if (label) {
                if (r.checked) {
                  label.classList.add('selected');
                } else {
                  label.classList.remove('selected');
                }
              }
            });
            
            // Sync UI and ATC text (centralized function handles everything)
            syncPurchaseTypeUIAndATC();
            
            // Update cart attributes if subscription
            if (plan && isSubscription && form) {
              updateCartAttributes(plan);
            }
          } catch(e) {
            console.warn('VelunaSub: Error updating frequency', e);
          }
        }, 300); // 300ms debounce
      }
    });
    
    // Initialize selected state on labels
    const subscriptionRadios = document.querySelectorAll('[data-velunasub-frequency]');
    subscriptionRadios.forEach(radio => {
      if (radio.checked) {
        const label = radio.closest('label');
        if (label) {
          label.classList.add('selected');
        }
      }
    });
  }
  
  // Setup frequency handlers on load
  setupFrequencyHandlers();
  
  // Handle form submission
  function setupFormSubmissionHandler() {
    const form = getProductForm();
    if (!form) return;
    
    form.addEventListener('submit', function(e) {
      console.log('[RECOVERY_CREAM] Form submit triggered');
      
      // Re-query button (handle Theme Editor rerenders)
      const addToCartBtn = document.querySelector('#recovery-cream-add-to-cart');
      
      // CRITICAL: Button state is now managed by VelunaATCController
      // No need to capture original state - controller handles it deterministically
      // After price injection, ensure button is ready
      if (addToCartBtn && window.VelunaAddToCart && typeof window.VelunaAddToCart.ensureATCReady === 'function') {
        // Controller will handle state management
        // Just ensure button is ready after price injection
        setTimeout(function() {
          window.VelunaAddToCart.ensureATCReady('rc-price-updated');
        }, 100);
      }
      
      // CRITICAL: Ensure drawer is not blocking form submission
      const drawer = document.querySelector('[data-cart-drawer]');
      if (drawer && !drawer.classList.contains('veluna-cart-drawer--open')) {
        // Drawer is closed, ensure it's not blocking
        drawer.style.pointerEvents = 'none';
        drawer.style.zIndex = '-9999';
        drawer.style.visibility = 'hidden';
      }
      
      const purchaseTypeRadio = document.querySelector('[data-velunasub-purchase-type]:checked');
      const purchaseType = purchaseTypeRadio ? purchaseTypeRadio.value : null;
      const isSubscription = purchaseType === 'subscribe';
      const checkedRadio = document.querySelector('[data-velunasub-frequency]:checked');
      
      if (isSubscription && checkedRadio) {
        const frequency = checkedRadio.value;
        const plan = subscriptionPlans[frequency];
        
        const planInput = form.querySelector('[data-velunasub-plan]');
        const frequencyInput = form.querySelector('[data-velunasub-frequency-input]');
        const discountInput = form.querySelector('[data-velunasub-discount]');
        
        if (planInput && !planInput.value) planInput.value = plan.plan;
        if (frequencyInput && !frequencyInput.value) frequencyInput.value = plan.frequency;
        if (discountInput && !discountInput.value) discountInput.value = plan.discount;
        
        console.log('✅ VelunaSub form submitted with subscription:', {
          plan: plan.plan,
          frequency: plan.frequency,
          discount: plan.discount
        });
      } else {
        // One-time purchase: clear all subscription properties to ensure full price is used
        const planInput = form.querySelector('[data-velunasub-plan]');
        const frequencyInput = form.querySelector('[data-velunasub-frequency-input]');
        const discountInput = form.querySelector('[data-velunasub-discount]');
        
        if (planInput) planInput.value = '';
        if (frequencyInput) frequencyInput.value = '';
        if (discountInput) discountInput.value = '';
        
        // Ensure button shows full price (no discount) - use controller
        if (addToCartBtn) {
          if (window.VelunaAddToCart && window.VelunaAddToCart.controller) {
            window.VelunaAddToCart.controller.render(addToCartBtn, {
              labelText: 'Add to Cart'
            });
          } else {
            // Fallback: update label element if available
            var labelEl = addToCartBtn.querySelector('[data-atc-label]') || 
                         addToCartBtn.querySelector('.recovery-cream-hero__cta-text');
            if (labelEl) {
              labelEl.textContent = 'Add to Cart';
            }
          }
          addToCartBtn.classList.remove('recovery-cream-hero__cta--subscription');
        }
      }
    });
  }
  
  // Setup form submission handler
  setupFormSubmissionHandler();
  
  // Initialize savings amounts on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateSavingsAmounts);
  document.addEventListener('DOMContentLoaded', updateOnetimeCardPrices);
  // Update one-time card prices dynamically based on 1-month unit price
  function updateOnetimeCardPrices() {
    var unitPrice = (_unitPrice > 0) ? _unitPrice : _cachedProductPrice;
    if (!unitPrice || unitPrice <= 0) return;
    
    var cards = document.querySelectorAll('[data-velunasub-onetime-qty]');
    cards.forEach(function(radio) {
      var qty = parseInt(radio.value, 10) || 1;
      var label = radio.closest('label');
      if (!label) return;
      
      var priceSpan = label.querySelector('.recovery-cream-hero__schedule-price');
      var compareSpan = label.querySelector('.recovery-cream-hero__schedule-compare-price');
      if (!priceSpan) return;
      
      var discount = (qty === 3) ? 0.20 : (qty === 2) ? 0.10 : 0;
      var fullPrice = unitPrice * qty;
      var discountedPrice = fullPrice * (1 - discount);
      
      priceSpan.textContent = '$' + discountedPrice.toFixed(2);
      
      if (discount > 0) {
        if (!compareSpan) {
          compareSpan = document.createElement('span');
          compareSpan.className = 'recovery-cream-hero__schedule-compare-price';
          priceSpan.parentNode.appendChild(compareSpan);
        }
        compareSpan.textContent = '$' + fullPrice.toFixed(2);
        compareSpan.style.display = '';
      } else if (compareSpan) {
        compareSpan.style.display = 'none';
      }
    });
  }
  } else {
    updateSavingsAmounts();
  }
  
  // VELUNA_PROOF_TILE7_1 - Initialize CTA price on page load if subscription is selected
  function initializeCTAPrice() {
    const purchaseTypeChecked = document.querySelector('[data-velunasub-purchase-type]:checked');
    const isSubscription = purchaseTypeChecked && purchaseTypeChecked.value === 'subscribe';
    const addToCartBtn = document.querySelector('#recovery-cream-add-to-cart');
    const currentPrice = _cachedProductPrice;
    
    if (isSubscription && addToCartBtn && currentPrice > 0) {
      const subscriptionRadioChecked = document.querySelector('[data-velunasub-frequency]:checked');
      if (subscriptionRadioChecked) {
        const frequency = subscriptionRadioChecked.value;
        const plan = subscriptionPlans[frequency];
        if (plan) {
          const discountedPrice = (currentPrice * (1 - parseFloat(plan.discount) / 100)).toFixed(2);
          const originalPrice = currentPrice.toFixed(2);
          
          const priceSpan = addToCartBtn.querySelector('[data-cta-price], .recovery-cream-hero__cta-price');
          const compareSpan = addToCartBtn.querySelector('.recovery-cream-hero__cta-compare-price');
          
          if (priceSpan) {
            priceSpan.textContent = '$' + discountedPrice;
          }
          
          if (compareSpan) {
            compareSpan.textContent = '$' + originalPrice;
            compareSpan.style.display = '';
          }
          
          console.log('[VELUNA_PROOF_TILE7_1] CTA price initialized on page load', new Date().toISOString());
        }
      }
    }
  }
  
  // Initialize CTA price on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeCTAPrice();
      updateAddToCartPrice();
    });
  } else {
    // Small delay to ensure DOM is ready
    setTimeout(function() {
      initializeCTAPrice();
      updateAddToCartPrice();
    }, 100);
  }
  
  // Initialize other features (toggle sections, form prevention, cross-sell)
  function initHeroSection() {
    try {
      console.log('Recovery Cream Hero: Initializing other features...');
      const mainAddToCartButton = document.getElementById('recovery-cream-add-to-cart');
      if (!mainAddToCartButton) {
        return;
      }
      
      // Why Subscribe toggle
      const whySubscribeButton = document.querySelector('.recovery-cream-hero__why-subscribe-button');
      const whySubscribeContent = document.querySelector('.recovery-cream-hero__why-subscribe-content');
      
      if (whySubscribeButton && whySubscribeContent) {
        // Honor server-rendered open-by-default state. Only collapse if markup
        // explicitly requested it (no is-expanded class on the wrapper).
        var whySubscribeWrap = whySubscribeButton.closest('.recovery-cream-hero__why-subscribe');
        var startOpen = whySubscribeWrap && whySubscribeWrap.classList.contains('is-expanded');
        if (startOpen) {
          whySubscribeContent.style.display = 'block';
          whySubscribeContent.classList.add('is-expanded');
          whySubscribeButton.setAttribute('aria-expanded', 'true');
        } else {
          whySubscribeContent.style.display = 'none';
          whySubscribeContent.classList.remove('is-expanded');
        }
        
        whySubscribeButton.addEventListener('click', function(e) {
          e.preventDefault();
          const isExpanded = this.getAttribute('aria-expanded') === 'true';
          this.setAttribute('aria-expanded', !isExpanded);
          
          if (isExpanded) {
            whySubscribeContent.style.display = 'none';
            whySubscribeContent.classList.remove('is-expanded');
          } else {
            whySubscribeContent.style.display = 'block';
            whySubscribeContent.classList.add('is-expanded');
          }
        });
      }
      
      // Recovery Cream toggle sections
      const toggleButtons = document.querySelectorAll('.recovery-cream-hero__toggle-button');
      
      toggleButtons.forEach(function(button) {
        const content = button.nextElementSibling;
        
        if (content && content.classList.contains('recovery-cream-hero__toggle-content')) {
          content.style.display = 'none';
          content.classList.remove('is-expanded');
          
          button.addEventListener('click', function(e) {
            e.preventDefault();
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', !isExpanded);
            
            if (isExpanded) {
              content.style.display = 'none';
              content.classList.remove('is-expanded');
            } else {
              content.style.display = 'block';
              content.classList.add('is-expanded');
            }
          });
        }
      });
      
      // Main Add to Cart - Handled by veluna-add-to-cart.js
      console.log('Recovery Cream Hero: Add-to-cart is handled by veluna-add-to-cart.js');
      
      // Preserve a working form fallback. veluna-add-to-cart.js may enhance the
      // submit, but this section must not suppress or rewrite form semantics.
      const mainAddToCartForm = document.querySelector('.recovery-cream-hero__form');
      if (mainAddToCartForm) {
        const button = document.getElementById('recovery-cream-add-to-cart');
        if (button) {
          button.setAttribute('type', 'submit');
          button.removeAttribute('data-no-submit');
        }
      }
      
      console.log('Recovery Cream Hero: Add-to-cart is fully handled by veluna-add-to-cart.js');
      
      // Cross-sell verification and setup
      const crossSellWrapper = document.querySelector('[data-rc-cross-sell]');
      const crossSellItems = document.querySelectorAll('[data-rc-cross-sell] .recovery-cream-hero__cross-sell-item');
      console.log('Recovery Cream Hero: Cross-sell wrapper found:', !!crossSellWrapper);
      console.log('Recovery Cream Hero: Cross-sell items count:', crossSellItems.length);
      
      // Cross-sell add to cart handler (async/await only - NO dot-start chains)
      console.log('Recovery Cream Hero: Setting up cross-sell forms...');
      const crossSellForms = document.querySelectorAll('.recovery-cream-hero__cross-sell-form');
      console.log('Recovery Cream Hero: Found', crossSellForms.length, 'cross-sell forms');
      
      crossSellForms.forEach(function(form, index) {
        console.log('Recovery Cream Hero: Processing cross-sell form', index + 1);
        
        const variantInput = form.querySelector('input[name="id"]');
        const button = form.querySelector('.recovery-cream-hero__cross-sell-button');
        
        if (!variantInput || !variantInput.value || !button) {
          console.warn('Recovery Cream Hero: Cross-sell form', index + 1, 'missing variant ID or button');
          if (button && window.VelunaAddToCart && window.VelunaAddToCart.controller) {
            // Use controller to set locked state
            window.VelunaAddToCart.controller.setState(button, 'locked', {
              labelText: 'Not Available'
            });
          } else if (button) {
            // Fallback if controller not available (should not happen in production)
            // Even in fallback, only update sub-elements (same pattern as controller)
            var labelEl = button.querySelector('[data-atc-label]') || 
                         button.querySelector('.recovery-cream-hero__cta-text');
            if (labelEl) {
              labelEl.textContent = 'Not Available';
            }
            // Use controller API if available, otherwise minimal mutation
            if (window.VelunaAddToCart && typeof window.VelunaAddToCart.ensureATCReady === 'function') {
              // Controller will handle disabled state via ensureATCReady
              window.VelunaAddToCart.ensureATCReady('cross-sell-locked');
            }
          }
          return;
        }
        
        // Cross-sell forms now handled by veluna-add-to-cart.js via data-veluna-atc="1" attribute
        // Only prevent default form submission - let veluna-add-to-cart.js handle the click
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          e.stopPropagation();
          console.log('Recovery Cream Hero: Cross-sell form submit prevented - handled by veluna-add-to-cart.js');
          return false;
        }, true);
        
        // Ensure button has data-veluna-atc attribute for veluna-add-to-cart.js
        if (button) {
          button.setAttribute('data-veluna-atc', '1');
          if (variantInput && variantInput.value) {
            button.setAttribute('data-variant-id', variantInput.value);
          }
        }
      });
    } catch(e) {
      console.warn('Recovery Cream Hero: Error in initHeroSection', e);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      try {
        initHeroSection();
      } catch(e) {
        console.warn('Recovery Cream Hero: Script initialization failed', e);
      }
    });
  } else {
    try {
      initHeroSection();
    } catch(e) {
      console.warn('Recovery Cream Hero: Script initialization failed', e);
    }
  }
})();





